import { FALLBACK_CURRENCY, numberOr } from "../checkout/money";

const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;
const TIME_ONLY = /^\d{1,2}:\d{2}(:\d{2})?$/;

const amountFormatters = new Map();

const amountFormatter = (fractionDigits) => {
  if (!amountFormatters.has(fractionDigits)) {
    amountFormatters.set(
      fractionDigits,
      new Intl.NumberFormat("en-US", {
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits,
      })
    );
  }

  return amountFormatters.get(fractionDigits);
};

export const formatMoney = (money) => {
  const value = numberOr(money?.value, 0);
  const currency = money?.currency || FALLBACK_CURRENCY;

  return `${currency} ${amountFormatter(Number.isInteger(value) ? 0 : 2).format(value)}`;
};

export const parseDateTime = (value) => {
  if (value === null || value === undefined || value === "") return null;

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  if (typeof value === "number") {
    const fromEpoch = new Date(value);

    return Number.isNaN(fromEpoch.getTime()) ? null : fromEpoch;
  }

  const raw = String(value).trim();

  if (DATE_ONLY.test(raw)) return new Date(`${raw}T00:00:00`);

  if (TIME_ONLY.test(raw)) {
    const [hours, minutes, seconds] = raw.split(":");
    const today = new Date();

    today.setHours(Number(hours), Number(minutes), Number(seconds || 0), 0);

    return today;
  }

  const parsed = new Date(raw);

  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

const dateFormatter = new Intl.DateTimeFormat("en-US", {
  month: "short",
  day: "2-digit",
  year: "numeric",
});

export const formatOrderDate = (value) => {
  const parsed = parseDateTime(value);

  return parsed ? dateFormatter.format(parsed) : "";
};

export const formatOrderTime = (value) => {
  const parsed = parseDateTime(value);

  if (!parsed) return "";

  const hours = parsed.getHours();
  const meridiem = hours >= 12 ? "pm" : "am";
  const hour12 = hours % 12 === 0 ? 12 : hours % 12;

  return `${String(hour12).padStart(2, "0")}:${String(parsed.getMinutes()).padStart(2, "0")}${meridiem}`;
};

export const formatDateAndTime = (dateValue, timeValue) => {
  const date = formatOrderDate(dateValue);
  const time = formatOrderTime(timeValue ?? dateValue);

  if (!date) return time;
  if (!time) return date;

  return `${date} - ${time}`;
};

export const addSpan = (from, span, spanType) => {
  const start = parseDateTime(from);
  const amount = numberOr(span);

  if (!start || amount === null) return null;

  const hours = String(spanType || "H").toUpperCase() === "D" ? amount * 24 : amount;

  return new Date(start.getTime() + hours * 60 * 60 * 1000);
};
